import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/users/preferences")({
    beforeLoad: () => {
        throw redirect({ to: "/users/patients", replace: true });
    },
});
